import { Wrench, CircuitBoard, ScanSearch } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "../lib/scroll";
import { IMAGES } from "../constants/business";

const BRANDS = [
  { name: "Cummins", note: "RAM 2500 / 3500 Cummins pickups" },
  { name: "Duramax", note: "GM / Chevrolet & GMC HD trucks" },
  { name: "Power Stroke", note: "Ford Super Duty specialists" },
];

const CAPS = [
  { icon: Wrench, label: "Mechanical diesel repair" },
  { icon: CircuitBoard, label: "Electrical system diagnostics" },
  { icon: ScanSearch, label: "Computer & module diagnostics" },
];

export const DieselSection = () => (
  <section id="diesel" className="relative bg-zinc-950 border-y border-zinc-800 overflow-hidden" data-testid="diesel-section">
    <div className="grid grid-cols-1 lg:grid-cols-2">
      <div className="relative min-h-[320px] lg:min-h-full">
        <img
          src={IMAGES.diesel}
          alt="Mechanic working on a diesel pickup engine in an automotive garage"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-zinc-950/40 lg:bg-gradient-to-r" />
      </div>

      <div className="px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <Reveal>
          <p className="text-[#FF3B30] text-xs uppercase tracking-[0.35em] font-semibold mb-4">02 — Diesel Specialists</p>
          <h2 className="font-oswald font-bold uppercase tracking-tight text-4xl sm:text-5xl leading-[1.02]" data-testid="diesel-heading">
            Big Power.<br /><span className="text-zinc-500">Real Experience.</span>
          </h2>
          <p className="mt-6 text-zinc-400 text-base md:text-lg max-w-xl">
            We work on diesel pickups, duallys and work pickups every day — mechanical,
            electrical and computer diagnostics under one roof. If it runs on diesel, we know it.
          </p>
        </Reveal>

        <div className="mt-10 border-t border-zinc-800">
          {BRANDS.map((b, i) => (
            <Reveal key={b.name} delay={i * 0.1}>
              <div className="flex items-baseline justify-between gap-4 py-5 border-b border-zinc-800 group" data-testid={`diesel-brand-${b.name.toLowerCase().replace(/\s+/g, "-")}`}>
                <span className="font-oswald font-bold uppercase tracking-tight text-3xl sm:text-4xl group-hover:text-[#FF3B30] transition-colors duration-300">
                  {b.name}
                </span>
                <span className="text-xs sm:text-sm text-zinc-500 text-right">{b.note}</span>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap gap-3">
          {CAPS.map(({ icon: Icon, label }) => (
            <span key={label} className="flex items-center gap-2 border border-zinc-700 px-4 py-2 text-xs uppercase tracking-[0.15em] text-zinc-300">
              <Icon className="w-4 h-4 text-[#FF3B30]" strokeWidth={1.5} /> {label}
            </span>
          ))}
        </div>

        <Reveal delay={0.2}>
          <button
            onClick={() => scrollToId("request")}
            data-testid="diesel-request-btn"
            className="mt-12 bg-[#FF3B30] text-white font-oswald uppercase tracking-[0.15em] px-10 py-4 hover:bg-white hover:text-black transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-white focus-visible:outline-none"
          >
            Book Diesel Service
          </button>
        </Reveal>
      </div>
    </div>
  </section>
);
